import { useState, useEffect } from 'react';
import type { ReactNode } from 'react';
import Header from '../components/Header';
import MobileBottomNav from '../components/MobileBottomNav';
import NovoExame from '../pages/NovoExame';
import OnboardingTour from '../components/OnboardingTour';

interface ClientLayoutProps {
  children: ReactNode;
}

export default function ClientLayout({ children }: ClientLayoutProps) {
  const [isNovoExameModalOpen, setIsNovoExameModalOpen] = useState(false);

  // Escutar evento para abrir modal de novo exame
  useEffect(() => {
    const handleOpenModal = () => {
      setIsNovoExameModalOpen(true);
    };

    window.addEventListener('openNovoExameModal', handleOpenModal);

    return () => {
      window.removeEventListener('openNovoExameModal', handleOpenModal);
    };
  }, []);

  return (
    <div className="min-h-screen w-full bg-gray-50 flex flex-col m-0 p-0 text-gray-900">
      {/* Top Header with Logo, Company Switcher and User Profile */}
      <Header />

      {/* Main Content Area - Full width with centered max container (with responsive padding for mobile bottom bar) */}
      <main className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4 pb-24 md:py-8">
        {children}
      </main>

      {/* Barra de Navegação Inferior para Mobile */}
      <MobileBottomNav />

      {/* Novo Exame Modal */}
      <NovoExame
        isOpen={isNovoExameModalOpen}
        onClose={() => setIsNovoExameModalOpen(false)}
      />

      {/* Tour Interativo Onboarding Desktop */}
      <OnboardingTour />
    </div>
  );
}


